import { render, staticRenderFns } from "./ProgramHealthTab.vue?vue&type=template&id=e9b7a4aa"
import script from "./ProgramHealthTab.vue?vue&type=script&lang=ts"
export * from "./ProgramHealthTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports